import { render, staticRenderFns } from "./ThemeSettingsDirect.vue?vue&type=template&id=62bf4938&scoped=true"
import script from "./ThemeSettingsDirect.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf4938",
  null
  
)

export default component.exports